// extracted by mini-css-extract-plugin
export default {"legalText":"CmsProductBenefits-module__legalText-3OHfi1"};